import { Suspense } from 'react'
import { Route as ReactRoute, Routes } from 'react-router-dom'
import { useGame } from '../../contexts'
import Loading from '../loadings/simple'
import LoadingGame from '../loadings/loading_game'

const Route = ({ data }: any) => {
  const { gameLoading } = useGame()
  if (gameLoading) return <LoadingGame/>

  return (
    <Routes>
      {data.map(({ layout: Layout, data: item }: any, index: any) => (
        <ReactRoute key={index} element={<Suspense fallback={<Loading />}><Layout /></Suspense>}>
        {item.map(({ path, component: Component, ...route }: any, idx: any) => (
          <ReactRoute
            key={`${index}-${idx}`}
            path={path}
            element={<Component />}
            {...route}
            exact={route.exact || true}
          />
        ))}
        </ReactRoute>
      ))}
    </Routes>
  )
}

export default Route
